import { useAuth } from "../../auth/hooks/useAuth";
import { useDashboard } from "../hooks/useDashboard";

import WelcomeSection from "../components/WelcomeSection";
import StatsGrid from "../components/StatsGrid";
import AlertsList from "../components/AlertsList";
import QuickActions from "../components/QuickActions";
import RecentActivities from "../components/RecentActivities";
import CenterInfo from "../components/CenterInfo";
import LoadingSpinner from "../../../shared/components/LoadingSpinner";

const DashboardPage = () => {
  const { user } = useAuth();
  const { dashboardData, loading, error } = useDashboard();

  if (loading) {
    return (
      // <div className="flex items-center justify-center h-64">
      //   <div className="text-gray-500">Loading dashboard...</div>
      // </div>
      <LoadingSpinner />
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <p className="text-red-600">Error loading dashboard: {error}</p>
      </div>
      // <LoadingSpinner />
    );
  }

  const { center, statistics, recent_activities, alerts, quick_actions } =
    dashboardData;

  return (
    <div>
      <WelcomeSection user={user} center={center} />

      <AlertsList alerts={alerts} />

      <StatsGrid statistics={statistics} />

      <QuickActions quickActions={quick_actions} />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <RecentActivities activities={recent_activities} />

        <CenterInfo center={center} />
      </div>
    </div>
  );
};

export default DashboardPage;